import locationInput from './locationInput.json'
import brandContent from './brandContent.json'

const enGB = {
  brandContent,
  locationInput,
}

export default enGB
